import { css } from "styled-components";
import theme from "styled-theming";
import { rgba } from "polished";

import text from "./text";
import palletes from "../palletes";

export const kinds = theme.variants("mode", "kind", {
  link: {
    light: css`
      color: ${text.medium};
      -webkit-text-fill-color: ${text.medium};

      background-color: #e8eaf1;
    `,
    dark: css`
      color: #fff;
      -webkit-text-fill-color: #fff;

      background-color: #262a31;
    `,
  },

  smooth: {
    light: css<{
      variant?: keyof typeof palletes;
    }>`
      color: ${(props) => palletes[props.variant]};
      -webkit-text-fill-color: ${(props) => palletes[props.variant]};

      background-color: ${(props) => rgba(palletes[props.variant], 0.1)};
    `,
    dark: css<{
      variant?: string;
    }>`
      color: ${(props) => palletes[props.variant]};
      -webkit-text-fill-color: ${(props) => palletes[props.variant]};

      background-color: ${(props) => rgba(palletes[props.variant], 0.1)};
    `,
  },

  ghost: {
    light: css<{
      variant?: string;
    }>`
      color: ${(props) => palletes[props.variant]};
      -webkit-text-fill-color: ${(props) => palletes[props.variant]};

      border-color: ${(props) => palletes[props.variant]};
      background-color: transparent;
    `,
    dark: css<{
      variant?: string;
    }>`
      color: ${(props) => palletes[props.variant]};
      -webkit-text-fill-color: ${(props) => palletes[props.variant]};

      border-color: ${(props) => palletes[props.variant]};
      background-color: transparent;
    `,
  },
});
